"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedStaffNotification =
/*#__PURE__*/
function (_pb_1$StaffNotificati) {
  _inherits(ExtendedStaffNotification, _pb_1$StaffNotificati);

  function ExtendedStaffNotification(properties) {
    var _this;

    _classCallCheck(this, ExtendedStaffNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedStaffNotification).call(this, properties));
    _this.type = ExtendedStaffNotification.type;
    return _this;
  }

  _createClass(ExtendedStaffNotification, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.staff).concat(ExtendedStaffNotification.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.StaffNotification.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedStaffNotification(pb_1.StaffNotification.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedStaffNotification;
}(pb_1.StaffNotification);

ExtendedStaffNotification.type = "StaffNotification";
ExtendedStaffNotification.context = "/notification";
exports.StaffNotification = ExtendedStaffNotification;